/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

export type LoginErrorKey =
  | 'unprocessable_entity'
  | 'invalid_credentials'
  | 'network_error'
  | 'system_not_available'
  | 'invalid_client'
  | 'invalid_request'
  | 'not_authorized';

export const CREDENTIAL_ERROR_KEYS: LoginErrorKey[] = ['invalid_credentials', 'unprocessable_entity'];

export const ALLOWED_ERROR_KEYS: LoginErrorKey[] = [
  'unprocessable_entity',
  'invalid_credentials',
  'network_error',
  'system_not_available',
  'invalid_client',
  'invalid_request',
  'not_authorized',
];
